// Zentrale Liste aller Spiele im Games-Bereich.
import SnakeGame from "./SnakeGame";
import StackGame from "./StackGame";
import FlappyGame from "./FlappyGame";
import CrossyGame from "./CrossyGame";
import BlockBlastGame from "./BlockBlastGame";
import BubbleShooterGame from "./BubbleShooterGame";

// preview: 20x10-Pixelszene, wird als Banner auf den Karten gerendert.
// aspect: Breite/Höhe des Spiel-Canvas — steuert die Skalierung beim Spielen.
export const GAMES = [
  {
    id: "snake",
    name: "Snake",
    tagline: "Arena mit 3 Bots",
    desc: "Sammle Äpfel und weiche Wänden, dir selbst und den Bot-Schlangen aus.",
    controls: "Pfeiltasten / WASD · Mobil: Wischen",
    scoreLabel: "Äpfel",
    component: SnakeGame,
    accent: "#6abe30",
    aspect: 520 / 520,
    preview: {
      palette: {
        A: "#5d9e3f",
        B: "#569539",
        g: "#6abe30",
        d: "#4e9420",
        h: "#7ed641",
        r: "#d93a2b",
      },
      rows: [
        "ABABABABABABABABABAB",
        "BABABABABABABABABABA",
        "ABABABABABABABABABAB",
        "BABrBABABgggghBABABA",
        "ABABABABAgABABABABAB",
        "BABABABABgBABABABABA",
        "ABAdddggggABABABABAB",
        "BABABABABABABABABABA",
        "ABABABABABABABABABAB",
        "BABABABABABABABABABA",
      ],
    },
  },
  {
    id: "stack",
    name: "Stack",
    tagline: "Blöcke exakt stapeln",
    desc: "Stapel die wandernden Blöcke übereinander. Was übersteht, wird abgeschnitten.",
    controls: "Leertaste / Klick / Tippen",
    scoreLabel: "Blöcke",
    component: StackGame,
    accent: "#c98f4e",
    aspect: 420 / 640,
    preview: {
      palette: {
        B: "#1c2733",
        o: "#c98f4e",
        d: "#8a5a2b",
        m: "#8d8d8d",
        g: "#6abe30",
      },
      rows: [
        "BBBBBBBBBBBBBBBBBBBB",
        "BBBggggggBBBBBBBBBBB",
        "BBBBBBBBBBBBBBBBBBBB",
        "BBBBBBBmmmmmmBBBBBBB",
        "BBBBBBBddddddBBBBBBB",
        "BBBBBBBooooooBBBBBBB",
        "BBBBBBggggggggBBBBBB",
        "BBBBBBmmmmmmmmBBBBBB",
        "BBBBBooooooooooBBBBB",
        "BBBBBddddddddddBBBBB",
      ],
    },
  },
  {
    id: "flappy",
    name: "Flappy",
    tagline: "Durch die Lücken fliegen",
    desc: "Flattere durch die Lücken zwischen den Säulen. Eine Berührung beendet die Runde.",
    controls: "Leertaste / Klick / Tippen",
    scoreLabel: "Säulen",
    component: FlappyGame,
    accent: "#57b9e8",
    aspect: 420 / 640,
    preview: {
      palette: {
        s: "#57b9e8",
        G: "#6abe30",
        g: "#4e9420",
        y: "#f2b632",
        w: "#ffffff",
        b: "#1f2410",
      },
      rows: [
        "ssGGgsssssssssGGgsss",
        "ssGGgsssssssssGGgsss",
        "ssGGgsssssssssGGgsss",
        "ssGGgsssssssssssssss",
        "ssssssssyybsssssssss",
        "sssssssswyysssssssss",
        "ssssssssssssssGGgsss",
        "ssGGgsssssssssGGgsss",
        "ssGGgsssssssssGGgsss",
        "ssGGgsssssssssGGgsss",
      ],
    },
  },
  {
    id: "crossy",
    name: "Crossy",
    tagline: "Straßen überqueren",
    desc: "Hüpfe über die Straßen und weiche den Autos aus. Jede Reihe zählt einen Punkt.",
    controls: "Pfeiltasten / WASD · Mobil: Wischen & Tippen",
    scoreLabel: "Reihen",
    component: CrossyGame,
    accent: "#e8c34e",
    aspect: 440 / 640,
    preview: {
      palette: {
        A: "#5d9e3f",
        B: "#569539",
        r: "#3f3f3f",
        c: "#d93a2b",
        y: "#f2b632",
        w: "#ffffff",
      },
      rows: [
        "ABABABABABABABABABAB",
        "BABABABABABABABABABA",
        "rrrrrrrrrrrrrrrrrrrr",
        "rrrrccccrrrrryyyyrrr",
        "rrrrrrrrrrrrrrrrrrrr",
        "ABABABABABABABABABAB",
        "rrrrrrrrrrrrrrrrrrrr",
        "rrrrrrrrrccccrrrrrrr",
        "rrrrrrrrrrrrrrrrrrrr",
        "BABABABABwwABABABABA",
      ],
    },
  },
  {
    id: "blockblast",
    name: "Block Blast",
    tagline: "Reihen und Spalten räumen",
    desc: "Lege die Teile aufs 8x8-Brett. Volle Reihen und Spalten werden geräumt.",
    controls: "Ziehen / Tippen",
    scoreLabel: "Punkte",
    component: BlockBlastGame,
    accent: "#9b6ee8",
    aspect: 420 / 640,
    preview: {
      palette: {
        B: "#1c2733",
        b: "#202e3f",
        r: "#d93a2b",
        u: "#57b9e8",
        y: "#e8c34e",
        g: "#6abe30",
        p: "#9b6ee8",
      },
      rows: [
        "BbBbBbBbBbBbBbBbBbBb",
        "bBbBbBrrBbBbBbBbBbBb",
        "BbBbBbrrbBuuuBbBbBbB",
        "bBbBbBbBbBbBbBbBbBbB",
        "BbggBbBbBbBbBbppBbBb",
        "bBggbBbBbBbBbBppbBbB",
        "ByyyyBbuuBbBbBbBbBbB",
        "byyyybBuubBbBbBrrrbB",
        "BrrggyyuuppBbBbBbBbB",
        "brrggyyuuppbBbBbBbBb",
      ],
    },
  },
  {
    id: "bubbles",
    name: "Bubble Shooter",
    tagline: "Blasen zum Platzen bringen",
    desc: "Schieße Blasen ins Raster — ab drei gleichen Farben platzt die Gruppe.",
    controls: "Zielen & Klicken / Tippen · Pfeiltasten + Leertaste",
    scoreLabel: "Blasen",
    component: BubbleShooterGame,
    accent: "#57b9e8",
    aspect: 420 / 640,
    preview: {
      palette: {
        B: "#131c30",
        r: "#d93a2b",
        u: "#57b9e8",
        y: "#e8c34e",
        g: "#6abe30",
        p: "#9b6ee8",
        w: "#ffffff",
      },
      rows: [
        "rruuyyggppuurryyggBB",
        "BuuyyggrrppuuyyrrggB",
        "rryyBBuuggBBrrppBBuu",
        "BBggBBBBrrBBBByyBBBB",
        "BBBBBBBBuuBBBBBBBBBB",
        "BBBBBBBBBBBBBBBBBBBB",
        "BBBBBBBBBwBBBBBBBBBB",
        "BBBBBBBBBwBBBBBBBBBB",
        "BBBBBBBBgggBBBBBBBBB",
        "BBBBBBBBgggBBBBBBBBB",
      ],
    },
  },
];

export const getGame = (id) => GAMES.find((g) => g.id === id);
